import React, {FC, ReactNode, useState, useEffect} from "react";
import classNames from "classnames";
import Link from "next/link";
import {useDispatch, useSelector} from "react-redux";
import {useRouter} from "next/router";
import {Addresses, DownloadIcon, Logout, Orders, Profile} from "../../svg";
import {AddCartToken} from "../../store/token";
import shopApi from "../../api/shop";
import {IState} from "../../types/state";
import {getCartDataMount} from "../../store/cart";
import cls from "./account.module.scss"
import {setAuth, setCustomerGroupID, setToken} from "../../store/customer";
import {useGlobal} from "../../hooks/useGlobal";
import PageHeader from "../shared/PageHeader";
import {TranslationsType} from "../../types/homePageTypes";
import {wishListRemoveAllItems} from "../../store/wishlist";
import AccountNavigationMenu from "./AccountNavigationMenu";
import {clearOrders} from "../../store/orders/ordersActions";


interface IProps {
    children?: ReactNode
    breadcrumb: Array<{ title: string; url: string }>;
    translationsData: TranslationsType;
    selectedLocale: string,
    dbName: string
}

interface ILink {
    id: number;
    url: string;
    title: string;
    icon: ReactNode;
}

const AccountLayout: FC<IProps> = (
    {
        children,
        breadcrumb,
        translationsData,
        selectedLocale,
        dbName
    }
) => {
    const {selectedRate} = useGlobal();
    const [links, setLinks] = useState<ILink[]>([]);
    const history = useRouter();
    const dispatch = useDispatch();
    const {cartToken} = useSelector((state: IState) => state.cartToken);
    const isDownloadableOrder = !!useSelector((state: IState) => state.orders.downloadable).length;
    const customer = useSelector((state: IState) => state.customer);

    useEffect(() => {
        const baseLinks = [
            {
                id: 1,
                url: "profile",
                icon: <Profile />,
                title: translationsData.PersonalInformation
            },
            {
                id: 2,
                url: "orders",
                icon: <Orders className={cls["historyIcon-svg"]} />,
                title: translationsData.MyOrders
            },
            ...(isDownloadableOrder ? [{
                id: 3,
                icon: <DownloadIcon />,
                url: "downloadable-products",
                title: translationsData.DownloadableProducts
            }] : []),
            {
                id: 4,
                url: "addresses",
                icon: <Addresses />,
                title: translationsData.Address
            },
            {
                id: 5,
                url: "logout",
                icon: <Logout />,
                title: translationsData.SignOut
            }
        ];

        setLinks(baseLinks);
    }, [isDownloadableOrder]);

    const  logout = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        dispatch(setAuth(false));
        dispatch(setCustomerGroupID(1))
        dispatch(setToken(""));
        dispatch(clearOrders());

        shopApi.getCustomerLogoutToken(customer.token)
            .then(item => {
                if (item.ok) {
                    shopApi.getCheckoutCartToken()
                        .then(res => {
                            if (res.api_token) {
                                dispatch(AddCartToken(res.api_token));

                            }
                        })
                }
            })
        dispatch(getCartDataMount(cartToken, {token: ""}, selectedLocale, selectedRate ? selectedRate.code : ""));
        dispatch(wishListRemoveAllItems())

        history.push("/");
    };

    const newLinks = links.map((link: ILink) => {
        const classes = classNames(cls["account-nav__item"],
            history.route.includes(link.url) && cls["account-nav__item--active"]
        );
        const signOutProps = link.url === "logout" ? {onClick: logout, className: cls.logout} : {}
        return (
            <li key={link.id} className={classes}>
                <Link href={`/account/${link.url}`}>
                    <a
                        {...signOutProps}
                    >
                        <span>{link.icon}</span>
                        {link.title}
                    </a>
                </Link>
            </li>
        );
    });

    return (
        <>
            <PageHeader dbName={dbName} breadcrumb={breadcrumb}/>
            <h1 className={cls["account-nav__title"]}>
                {translationsData.MyAccount}
            </h1>
            <div className={cls.block}>
                <div className="container">
                <div className={cls["account-layout-wrapper"]}>
                    <AccountNavigationMenu links={newLinks} />
                    <div className={`${cls["account-layout"]} ${cls["account-layout-desktop"]}`}>
                {children}
            </div>
            </div>
                </div>
            </div>
        </>
    );
};

export default AccountLayout;
